<template>
	<div class="swiper-container" id="imgSw">
		<div class="swiper-wrapper">
			<div class="swiper-slide" v-for="(item,index) in imgList" :key='index'>
				<img :src="item" class="swiperImg" />
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	export default {
		name: 'swiper',
		props:['imgList'],
		mounted: function() {
			//配置Swiper  建议关于Swiper配置方面可以前往Swiper官网
			new Swiper('#imgSw', {
				loop: true,
				freeMode: true,
				slidesPerView: 2,
				spaceBetween: 30,
				direction: 'vertical',
				speed: 4000,
				autoplay: {
					delay: 0,
					stopOnLastSlide:false,
					disableOnInteraction: false,
				},
				observer: true, //很重要
				observeParents:false
			})
		}
	}
</script>

<style scoped>
	.swiper-container {
		background: none;
		width: 100%;
		height: 100%;
	}

	.swiperImg {
		width:  100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}

	.swiper-container-free-mode>.swiper-wrapper {
		transition-timing-function: linear;
	}
</style>
